<template>
  <div class="EmojiReactions">
    <!-- one button per reaction, the emoji and the count; a hover
         anywhere on it shows who reacted -->
    <UserListPopover
      v-for="(reaction) in emojiReactions"
      :key="reaction.url || reaction.name"
      :user-ids="accountsForEmoji.get(reaction.name)"
      class="emoji-reaction-container"
      trigger-tag="span"
      :category="`emoji:${reaction.url || reaction.name}`"
      :load="loadPeople"
      :needs-load="!reaction.account_ids && !reaction.accounts"
    >
      <component
        :is="loggedIn ? 'button' : 'a'"
        v-bind="!loggedIn ? { href: remoteInteractionLink } : {}"
        role="button"
        class="emoji-reaction btn button-default"
        :class="{ '-picked-reaction': reactedWith(reaction.name), toggled: reactedWith(reaction.name) }"
        :title="reaction.url ? reaction.name : undefined"
        :aria-label="reactionLabel(reaction)"
        :aria-pressed="reactedWith(reaction.name)"
        @click="emojiOnClick(reaction.name, $event)"
      >
        <span
          class="reaction-emoji"
          :class="{ ['-wide']: allowNonSquareEmoji }"
        >
          <ReactionEmoji
            class="reaction-emoji-content"
            :class="{ 'reaction-emoji': !reaction.url }"
            :name="reaction.name"
            :url="reaction.url"
          />
        </span>
        <FALayers>
          <FAIcon
            v-if="reactedWith(reaction.name)"
            class="active-marker"
            transform="shrink-6 up-9"
            icon="check"
          />
          <FAIcon
            v-if="!reactedWith(reaction.name)"
            class="focus-marker"
            transform="shrink-6 up-9"
            icon="plus"
          />
          <FAIcon
            v-else
            class="focus-marker"
            transform="shrink-6 up-9"
            icon="minus"
          />
        </FALayers>
        <span class="emoji-reaction-counts">{{ reaction.count }}</span>
      </component>
    </UserListPopover>
    <a
      v-if="tooManyReactions"
      class="emoji-reaction-expand faint"
      href="javascript:void(0)"
      @click="toggleShowAll"
    >
      {{ showAll ? $t('general.show_less') : showMoreString }}
    </a>
  </div>
</template>

<script src="./emoji_reactions.js"></script>

<style src="./emoji_reactions.scss" lang="scss" />
